import React from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

const HideMembershipTier = ({ visible, onChange }) => {
  return (
    <Box>
      <FormControlLabel
        label="Publicly listed"
        control={
          <Checkbox
            name="visible"
            checked={visible}
            onChange={onChange}
            size="small"
          />
        }
      />
    </Box>
  );
};

HideMembershipTier.propTypes = {
  visible: PropTypes.bool,
  onChange: PropTypes.func,
};

export default HideMembershipTier;
